import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import BaseTimeAgo from 'react-timeago';
import defaultFormatter from 'react-timeago/lib/defaultFormatter';

const WEEKS_IN_MONTH = 4.34812141;
const timeUnits = {
    second: 's',
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w',
    month: 'mo',
    year: 'y',
};
function longDateFormatter(value, unit) {
    if ((value === 1 && unit === 'day') || (value === 24 && unit === 'hour'))
        return 'Yesterday';
    return unit === 'second' ? 'Now' : defaultFormatter.apply(null, arguments);
}
function shortDateFormatter(value, unit, sufix = null, showSufix = false) {
    if (unit === 'second')
        return 'Now';
    let formattedDate;
    if (unit === 'month') {
        formattedDate = `${Math.round(value * WEEKS_IN_MONTH)}${timeUnits.week}`;
    }
    else {
        formattedDate = `${value}${timeUnits[unit]}`;
    }
    if (showSufix) {
        return `${formattedDate} ${sufix}`;
    }
    return `${formattedDate}`;
}
const TimeAgo = (_a) => {
    var { date, short = false, showShortDateSufix = false, hideTitle = false } = _a, props = __rest(_a, ["date", "short", "showShortDateSufix", "hideTitle"]);
    return (jsx(BaseTimeAgo, Object.assign({ date: date, title: !hideTitle ? new Date(date).toLocaleString() : undefined, formatter: short
            ? (value, unit, sufix) => shortDateFormatter(value, unit, sufix, showShortDateSufix)
            : longDateFormatter }, props)));
};

export { TimeAgo, longDateFormatter, shortDateFormatter, timeUnits };
